type PaginationType = {
    postPerPage: number,
    increasePage: () => void;
    decreasePage: () => void;
    setPage: any
    totalPosts: number
    page: number
}
export const Pagination = ({page, setPage, postPerPage, totalPosts, decreasePage, increasePage}: PaginationType) => {
    const pages = []
    const totalPages = Math.ceil(totalPosts / postPerPage)

    for (let i = 1; i <= totalPages; i++) {
        pages.push(i)
    }
    const currPage = page > totalPages ? setPage() : page
    return (
        <div style={{marginLeft: "1rem", marginTop: "1.5rem"}}>
            {totalPages ?
                <>
                    <button disabled={page == 1} onClick={decreasePage} style={{color: "#94a3b8"}}
                            className={"button is-secondary"}>&#60;</button>
                    <button style={{
                        color: "#94a3b8",
                        fontSize: "1.6rem",
                        margin: "10px"
                    }}> {currPage}/{totalPages}</button>
                    <button disabled={page >= totalPages} onClick={increasePage} style={{color: "#94a3b8"}}
                            className={"button is-secondary"}>&#62;</button>
                </>
                : ""
            }
        </div>
    )
}